<template>
  <div class="hot">
    <div :class="[length > 3 ? 'hot_active_four' : 'hot_active']" v-for="(item, index) in options" :key="index" @click="goDetail(item)" v-has="item.isShowCode">
      <div class="bottom_img" :style="{ background: item.background }"><img :src="item.src" alt=""></div>
      <span>{{item.name}}</span>
      <div class="shopOil"><img src="https://web.nlktj.com/ty/merchant-h5/fire.png" alt="">{{item.count || 0}}座油站累计参加</div>
    </div>
  </div>
</template>
<script>
import { joinCompanyNum, marketCenter, getLuckDrawApplicantsCount, canJoinOrder } from '@/api/marketPromotion'
export default {
  data () {
    const _this = this
    return {
      length: 3,
      options: [
         {
          id: 12,
          jumpUrl: '/promotion/comeOrder',
          src: `${_this.$ossUrl}persisMarket/come-order.png`,
          name: '商户冲单',
          count: 0,
          isShowCode: 'comeOrder',
          background: '#FF457A',
        },
        {
          id: 8,
          jumpUrl: '/promotion/sendWater',
          src: `${_this.$ossUrl}persisMarket/perOne.png`,
          name: '加油送箱水',
          count: 0,
          isShowCode: 'water',
          background: '#FFDE8F',
        },
        {
          id: 7,
          jumpUrl: '/promotion/daySpecial',
          src: `${_this.$ossUrl}persisMarket/perThird.png`,
          name: '天天特价',
          count: 0,
          isShowCode: 'daySpecial',
          background: '#6150ED',
        },
         {
          id: 9,
          jumpUrl: '/promotion/limitShop',
          src: `${_this.$ossUrl}persisMarket/perSec.png`,
          name: '限时秒杀',
          count: 0,
          isShowCode: 'limitShop',
          background: '#FFD56F',
        },
        {
          id: 11,
          jumpUrl: '/promotion/treasure',
          src: `${_this.$ossUrl}persisMarket/perFou.png`,
          name: '抽奖宝',
          count: 0,
          isShowCode: 'treasureBtn',
          background: '#3E4DD6',
        }
      ]
    }
  },
  mounted () {
    this.joinCompanyNumApi()
    this.marketCenterApi()
    this.getLuckDrawApplicantsCountApi()
  },

  methods: {
    async goDetail (item) {
      this.$track.clickEvent('工作台-热门活动', '1628236690', { tysj_trade_type: item.name })
      if (item.id === 12) {
        // 商户冲单，是否参加过，不能直接跳，必须要判断一次
        const { result } = await canJoinOrder()
        if(result.status === 2) { return this.$message.info('该活动目前已结束，请下期及时报名参加') }
        this.$router.push({ path: item.jumpUrl, query: { ruleId: result.ruleId }})
      } else {
        this.$router.push({ path: item.jumpUrl })
      }
    },
    // 获取油站数量接口
    async joinCompanyNumApi () {
      try {
        const { code, result } = await joinCompanyNum()
        if(code !== 200) return
        result.forEach(item => {
          if (item.activityType === 7) {
            this.options[2].count = item.joinActivityCount
          } else [
            this.options[3].count = item.joinActivityCount
          ]
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 送水，冲单，油站数量
    async marketCenterApi () {
      try {
        const { code, result: { dtoList } } = await marketCenter({ activityTypes: '8,12' })
        if (code !== 200) return
        // this.options[0].count = result.dtoList[0].joinedGasCount
        for (var i = 0; i<dtoList.length; i++) {
          for (var j = 0; j<this.options.length; j++) {
            if (dtoList[i].activityType === this.options[j].id) {
              this.options[j].count = dtoList[i].joinedGasCount
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 抽奖宝油站数量
    async getLuckDrawApplicantsCountApi () {
      try {
        const { code, result } = await getLuckDrawApplicantsCount()
        if(code !== 200) return
        this.options[4].count = result
       } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style scoped lang="less">
.hot{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .hot_active, .hot_active_four{
    width: 33%;
    max-width:272px;
    min-width: 198px;
    margin-right: 1%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    cursor: pointer;
    .bottom_img{
      width: 100%;
      display: flex;
      border-radius: 4px;
      justify-content: center;
      align-items: center;
      >img{
        display: block;
        width: 199px;
        height: 100px;
      }
    }
    >span{
      margin: 5px 0 5px 5px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .shopOil{
      margin-left: 5px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      display: flex;
      justify-content: flex-start;
      >img{
        display: block;
        width: 8px;
        height: 11px;
        margin-right: 4px;
      }
    }
  }
  .hot_active_four{
    width: 24%;
    min-width: 198px;
  }
}
</style>